module.exports = __webpack_public_path__ + "img/DateTime.88e0bfb1.svg";